import { getMessagesParticipant } from "../../../api/messages";
import { GET_MESSAGES_PARTICIPANT } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

/**
 * Fetches participant data for a specific chat.
 *
 * @param {number | string} userId - The ID of the current user.
 * @param {number | string} chatId - The ID of the specific chat.
 * @param {number | null} [pollingMs=null] - Optional polling interval in milliseconds.
 */
export const useGetMessagesParticipant = (userId, chatId, pollingMs = null) => {
  const { data, isLoading, refetch, error } = useQuery(
    [GET_MESSAGES_PARTICIPANT, userId, chatId],
    () => getMessagesParticipant(userId, chatId),
    {
      enabled: !!userId && !!chatId,
      refetchInterval: pollingMs ?? false,
      retry: 1,
      retryDelay: 1000,
    }
  );

  return {
    participantData: data?.data,
    participantLoading: isLoading,
    refetchParticipant: refetch,
    participantError: error,
  };
};
